import React, { useState } from 'react'

import * as MdIcons from 'react-icons/md'
import { useTheme } from 'styled-components'

import { Container, TextAreaContainer, TextInput } from './styles'

interface IProps {
  onSave: (comment: string) => void
}

export function Input({ onSave }: IProps) {
  const theme = useTheme()
  const [comment, setComment] = useState('')

  function handleInputTextChange(text: string) {
    setComment(text)
  }

  function handleOnSave() {
    onSave(comment)
    setComment('')
  }

  return (
    <Container>
      <TextAreaContainer>
        <TextInput
          placeholder="Add comment..."
          autoComplete="off"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputTextChange(e.target.value)}
          value={comment}
        />
      </TextAreaContainer>
      {comment && (
        <button onClick={handleOnSave} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
          <MdIcons.MdAddComment size={30} color={theme.colors.text} />
        </button>
      )}
    </Container>
  )
}
